var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"none",class:{ active: _vm.type === 'white', gray: _vm.type === 'gray' }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-box"},[_c('div',{staticClass:"image-empty-item"},[_c('img',{attrs:{"src":require("../assets/img/placeholder.png")}})]),_c('div',{staticClass:"word"},[_vm._v(" 暂 无 记 录 ")])])
}]

export { render, staticRenderFns }